import { Box, Grid, Typography } from '@mui/material';
import { CatalogChartRenderer } from 'charts/components/CatalogChartRenderer';
import { ChartResultStatus } from 'charts/catalog/types';
import { INSPECTION_TRIPLET_CHART_ID } from 'charts/constants/catalogInspectionCharts';
import React, { ReactElement } from 'react';
import { MemoChartReloader } from '../../chartReloader';
import { SectionChartCard } from '../SectionChartCard';
import {
  inspectionSummarySubsectionSx,
  sectionLabelSx,
  sectionSx,
} from '../styles';
import type { InspectionSummarySubsectionPresentationalProps } from '../types';

export function InspectionSummarySubsectionPresentational({
  sectionLabel,
  parts,
  chart,
  chartRuntime,
}: InspectionSummarySubsectionPresentationalProps): ReactElement {
  const loading = chart.status === ChartResultStatus.loading;

  return (
    <Box sx={inspectionSummarySubsectionSx}>
      <Typography component="p" sx={sectionLabelSx}>
        {sectionLabel}
      </Typography>
      <MemoChartReloader context={chartRuntime}>
        <Grid container spacing={3} sx={sectionSx}>
          {parts.map(({ part, title, subtitle }) => (
            <Grid item key={part} xs={12} md={6} lg={4}>
              <SectionChartCard
                chartId={INSPECTION_TRIPLET_CHART_ID}
                loading={loading}
                title={title}
                subtitle={subtitle}
                // Each tile shows one part of the summary: the whole is exported from its details.
                exportable={false}
              >
                <CatalogChartRenderer
                  chartId={INSPECTION_TRIPLET_CHART_ID}
                  tripletPart={part}
                />
              </SectionChartCard>
            </Grid>
          ))}
        </Grid>
      </MemoChartReloader>
    </Box>
  );
}

export const MemoInspectionSummarySubsectionPresentational = React.memo(
  InspectionSummarySubsectionPresentational
);
